export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-film-line', description: '精选全球热门电影，涵盖动作、喜剧、科幻、爱情等多元类型' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', description: '国产剧、韩剧、美剧、日剧等热门电视剧一网打尽' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line', description: '最新热门综艺节目，搞笑、音乐、竞技、真人秀应有尽有' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '日漫、国漫、美漫等精品动漫作品，持续更新中' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '自然、历史、科技、人文等高品质纪录片汇聚' },
];

export const hotMovies = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    category: 'dianying',
    categoryName: '电影',
    year: 2026,
    rating: 8.7,
    description: '人类在星际探索中发现全新文明，一场跨越银河系的冒险就此展开。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20spaceship%20and%20distant%20galaxy%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20coral%20and%20gold%20color%20accents%2C%20movie%20poster%20style%2C%20clean%20background%2C%20professional%20film%20photography&width=600&height=800&seq=hongtao-movie-01&orientation=portrait',
  },
  {
    id: 2,
    title: '长安十二时辰',
    category: 'dianshiju',
    categoryName: '电视剧',
    year: 2026,
    rating: 9.2,
    description: '大唐盛世下的悬疑惊险故事，十二时辰内拯救长安城的壮丽史诗。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20ancient%20Tang%20Dynasty%20palace%20scene%2C%20warm%20golden%20lighting%2C%20traditional%20Chinese%20architecture%2C%20dramatic%20cinematic%20composition%2C%20movie%20poster%20style%2C%20elegant%20and%20mysterious%20atmosphere&width=600&height=800&seq=hongtao-movie-02&orientation=portrait',
  },
  {
    id: 3,
    title: '极限挑战第十季',
    category: 'zongyi',
    categoryName: '综艺',
    year: 2026,
    rating: 8.9,
    description: '明星嘉宾挑战极限任务，欢笑与泪水交织的真人秀盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20variety%20show%20poster%2C%20celebrities%20in%20dynamic%20action%20poses%2C%20colorful%20energetic%20atmosphere%2C%20bright%20studio%20lighting%2C%20entertainment%20show%20style%2C%20warm%20coral%20and%20golden%20accents%2C%20clean%20composition&width=600&height=800&seq=hongtao-movie-03&orientation=portrait',
  },
  {
    id: 4,
    title: '暗影猎手',
    category: 'dongman',
    categoryName: '动漫',
    year: 2026,
    rating: 9.0,
    description: '少年在黑暗中觉醒猎手之力，踏上守护世界的热血旅程。',
    image: 'https://readdy.ai/api/search-image?query=Anime-style%20dark%20fantasy%20poster%2C%20young%20warrior%20with%20mystical%20powers%2C%20dramatic%20lighting%20effects%2C%20cool%20character%20design%2C%20Japanese%20animation%20aesthetic%2C%20dynamic%20action%20pose%2C%20rich%20warm%20color%20palette%2C%20clean%20composition&width=600&height=800&seq=hongtao-movie-04&orientation=portrait',
  },
  {
    id: 5,
    title: '地球脉动：海洋深处',
    category: 'jilupian',
    categoryName: '纪录片',
    year: 2026,
    rating: 9.5,
    description: '潜入深海探索未知世界，呈现海洋生命的壮丽奇观。',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20deep%20ocean%20with%20bioluminescent%20sea%20creatures%2C%20majestic%20underwater%20scene%2C%20cinematic%20documentary%20style%2C%20vibrant%20marine%20life%2C%20professional%20nature%20photography%2C%20warm%20and%20cool%20contrasting%20tones&width=600&height=800&seq=hongtao-movie-05&orientation=portrait',
  },
  {
    id: 6,
    title: '逆光而行',
    category: 'dianying',
    categoryName: '电影',
    year: 2026,
    rating: 8.5,
    description: '一位盲人摄影师用心灵捕捉世界之美，感人至深的励志故事。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20drama%20film%20poster%2C%20silhouette%20of%20person%20with%20camera%20against%20warm%20sunset%20light%2C%20emotional%20cinematic%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20inspiring%20and%20warm%20tone%2C%20film%20poster%20design%2C%20clean%20elegant%20composition&width=600&height=800&seq=hongtao-movie-06&orientation=portrait',
  },
  {
    id: 7,
    title: '美食探秘：寻味中国',
    category: 'zongyi',
    categoryName: '综艺',
    year: 2026,
    rating: 8.8,
    description: '走遍中国大街小巷，探寻最地道的地方美食文化。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20delicious%20traditional%20Chinese%20cuisine%20close-up%2C%20warm%20appetizing%20lighting%2C%20steaming%20hot%20dishes%2C%20rich%20colors%2C%20food%20photography%20style%2C%20inviting%20composition%2C%20coral%20and%20golden%20warm%20tones&width=600&height=800&seq=hongtao-movie-07&orientation=portrait',
  },
  {
    id: 8,
    title: '风云再起',
    category: 'dianshiju',
    categoryName: '电视剧',
    year: 2026,
    rating: 8.6,
    description: '商界风云变幻，一群年轻人在时代浪潮中拼搏奋斗的励志故事。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20business%20drama%20poster%2C%20young%20professionals%20in%20city%20skyline%2C%20sophisticated%20urban%20atmosphere%2C%20warm%20cinematic%20lighting%2C%20professional%20lifestyle%20aesthetic%2C%20clean%20modern%20composition%2C%20coral%20accent%20colors&width=600&height=800&seq=hongtao-movie-08&orientation=portrait',
  },
];

export const latestUpdates = [
  { id: 1, title: '流浪地球3', episode: '抢先版', category: '电影', time: '2小时前' },
  { id: 2, title: '庆余年第三季', episode: '第8集', category: '电视剧', time: '4小时前' },
  { id: 3, title: '乘风破浪的姐姐2026', episode: '第5期', category: '综艺', time: '6小时前' },
  { id: 4, title: '进击的巨人最终季', episode: '第12集', category: '动漫', time: '8小时前' },
  { id: 5, title: '航拍中国第五季', episode: '第3集', category: '纪录片', time: '10小时前' },
  { id: 6, title: '唐人街探案4', episode: '高清版', category: '电影', time: '12小时前' },
];

export const latestArticles = [
  {
    id: 1,
    title: '2026年暑期档最值得期待的十部电影',
    summary: '暑期档大片云集，从科幻巨制到温情文艺片，我们为你精选了今夏不容错过的十部佳作。',
    date: '2026-08-08',
    category: '电影资讯',
    image: 'https://readdy.ai/api/search-image?query=Cinema%20interior%20with%20movie%20posters%20on%20wall%2C%20warm%20theater%20lighting%2C%20film%20reels%20and%20popcorn%2C%20artistic%20cinema%20photography%2C%20cozy%20atmosphere%2C%20rich%20coral%20and%20gold%20tones%2C%20professional%20composition&width=800&height=500&seq=hongtao-article-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国产动漫崛起：从《哪吒》到《深海》的蜕变之路',
    summary: '中国动画电影正在经历一场前所未有的复兴，技术突破与故事创新齐头并进。',
    date: '2026-08-06',
    category: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20working%20on%20digital%20tablets%2C%20creative%20workspace%2C%20colorful%20character%20designs%20on%20screen%2C%20warm%20studio%20lighting%2C%20modern%20creative%20environment%2C%20artistic%20composition&width=800&height=500&seq=hongtao-article-02&orientation=landscape',
  },
  {
    id: 3,
    title: '高分纪录片推荐：打开世界的另一种方式',
    summary: '十部改变认知的纪录片，带你领略自然奇观、人文历史与科技前沿的无限魅力。',
    date: '2026-08-04',
    category: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20screening%20room%2C%20large%20projection%20screen%20showing%20nature%20scene%2C%20warm%20ambient%20lighting%2C%20comfortable%20seating%2C%20cinematic%20atmosphere%2C%20educational%20and%20inspiring%2C%20rich%20warm%20tones&width=800&height=500&seq=hongtao-article-03&orientation=landscape',
  },
];

export const heroSlides = [
  {
    id: 1,
    title: '红桃影视',
    subtitle: '海量高清影视，随时随地畅享',
    description: '汇聚全球优质影视资源，每日更新，高清流畅播放',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20home%20theater%20with%20large%20screen%20displaying%20vibrant%20movie%20scene%2C%20warm%20cozy%20living%20room%20atmosphere%2C%20soft%20ambient%20lighting%2C%20modern%20interior%20design%2C%20entertainment%20lifestyle%2C%20rich%20coral%20and%20golden%20warm%20tones%2C%20cinematic%20photography&width=1920&height=1080&seq=hongtao-hero-01&orientation=landscape',
  },
];